export const advisorInitialState = {
  advisors: [],
  loading: false,
  error: null,
}
